module.exports = __webpack_public_path__ + "img/ship-right.29a88ace.png";